import { v4 as uuid } from "uuid";

export function makeId() {
  return uuid();
}
